import Vue from 'vue';

Vue.mixin({
  methods: {
    getProductItemField(productId, productItemId, field) {
      const product = this._.find(this.products, {id: productId + ''});
      const productItem = product ? this._.find(product.items,
          {id: productItemId + ''}) : null;

      return productItem ? productItem[field] : '';
    },
    async mergeCart(items = []) {
      if (items.length > 0) {
        const el = this.$createElement;
        let albums = [];

        items.forEach((album) => {
          let products = [];

          album.products.forEach((product) => {
            products.push(el('li', {}, [
              /*el('div', {class: ['pr-3', 'text-muted']}, [
                el('b-form-checkbox', {
                  props: {
                    'v-model': product.checked
                  }
                }),
              ]),*/
              el('img', {
                attrs: {
                  src: this.getProductItemField(product.product_category_id,
                      product.product_id, 'thumb_image'),
                  width: '100',
                  alt: '',
                },
              }),
              el('div', {class: 'pl-3'},
                  this.getProductItemField(product.product_category_id,
                      product.product_id, 'name')),
            ]));
          });

          albums.push(
              el('h5', {class: 'mb-4'}, album.album_title),
              el('ul', {}, products),
          );
        });

        const content = [
          el('p', {class: 'mb-3'},
              'Lorem ipsum dolor sit amet, consectetur adipisicing?'),
          el('div', {class: ['merge-cart-items']}, albums),
        ];

        this.$bvModal.msgBoxConfirm(content, {
          title: 'Merge shopping cart',
          size: 'lg',
          okTitle: this.$t('ok'),
          cancelTitle: this.$t('cancel'),
          centered: true,
        }).then(value => {
          if (value) {
            this.$store.dispatch('MERGE_PRODUCTS', items);
          } else {
            this.axios.post('v2/cart', {
              payload: JSON.stringify(this.cart),
            });
          }
        }).catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e);
        });
      }
    },
  },
});
